import http from '../../http'

const getTiers = (page, currentQuery) => http.get(`tiers?page=${page}${currentQuery ?? ''}`)
const getTier = (id) => http.get(`tiers/${id}`)
const createTier = (data) => http.post(`tiers`, data)
const updateTier = (id, data) => http.patch(`tiers/${id}`, data)

export {
  getTiers,
  getTier,
  createTier,
  updateTier
}